module.exports = __webpack_public_path__ + "static/media/Poppins-RegularItalic-latinext.efd6a6a1.woff2";